<template>
    <div>
        <div class="flex mb-2">
            <div class="wavestyle mr-5 cursor-pointer bg-style-line"
                 @click="setWaveStyle('line')"
                 :class="{active: (waveStyle === 'line')}"
            >
            </div>

            <div class="wavestyle mr-5 cursor-pointer bg-style-classic"
                 @click="setWaveStyle('classic')"
                 :class="{active: (waveStyle === 'classic')}"
            >
            </div>

            <div class="wavestyle mr-5 cursor-pointer bg-style-bar"
                 @click="setWaveStyle('bar')"
                 :class="{active: (waveStyle === 'bar')}"
            >
            </div>

            <div class="wavestyle cursor-pointer bg-style-modern"
                 @click="setWaveStyle('modern')"
                 :class="{active: (waveStyle === 'modern')}"
            >
            </div>
        </div>
    </div>
</template>

<script>
import Pipeline from "~/scripts/Pipeline/Pipeline.js";

export default {
    data() {
        return {
            waveStyle: 'line'
        };
    },

    mounted() {
        var waveConfigurations = this.$store.state.waveConfigurations;
        this.waveStyle = waveConfigurations[0] ? waveConfigurations[0].style : 'line';
    },
    methods: {
        /**
         * Change style for ALL waves
         */
        setWaveStyle(style) {
            this.waveStyle = style;

            this.$store.commit('setGlobalWaveStyle', style);

            setTimeout(() => {
                Pipeline.soundFilesToWaveForm();
            }, 100);
        }
    }
}
</script>
